export const isInWorker = () => typeof WorkerGlobalScope !== 'undefined';
